import { useOgTenantInfo } from '../../controllers/index.tsx';

type ExtendedError = Error & { skipSentry?: boolean };

export const ConsolidatedStateError = () => {
	const { shouldUseJSM, error } = useOgTenantInfo();

	if (error || !shouldUseJSM) {
		const consolidatedError: ExtendedError = new Error('Not consolidated');
		consolidatedError.skipSentry = true;
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		const extendedError = error as ExtendedError;
		if (extendedError) {
			extendedError.skipSentry = true;
		}
		throw extendedError || consolidatedError;
	}
	return null;
};
